export const BRAND_NAME = 'PlayExch247';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'playexch247.in';
export const PROVIDER_ID = 'BetFair';
